import React from 'react';
import { Logger } from 'aws-amplify';
import { PrimaryButton, SecondaryButton, RadioButtons } from 'wf-react-component-library';
import { Multiselect } from './multiselect/multiselect.component';
import { 
  getVendorItemCustomersByVendorItemId, 
  postVendorItemCustomer, 
  deleteVendorItemCustomer,
  getVendorForCustomerMapping } from '../api/p3/VendorItemCustomerApi';
import formatCurrency from '../utilities/currency-formatter';
import PulseModal from './PulseModal'

import './MaintainCustomers.scss';

const logger = new Logger('MaintainCustomers.js');

class MaintainCustomers extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          data: this.props.data,
          customersRemoved: [],
          customersAdded: [],
          customersUpdated: [],
          currentItemLocation: 0,
          isSaving: false,
          vendorItemCustomers: [],
          vendorItemCustomerMultiple: [],
          errorMessages: [],
          displaySetupOptions: false,
          shouldEditAllItems: false,
          shouldEditIndividualItems: false,
          editOptions: {
            all: 'Apply Changes to All Selected Items',
            each: 'Edit Each Item Individually'
          },
          isloadingCustomers: false,
          displayMultiSelect: false,
          changeMessages: []
      };

      this.onSelect = this.onSelect.bind(this);
      this.onRemove = this.onRemove.bind(this);
      this.onUpdate = this.onUpdate.bind(this);
      this.onAdd = this.onAdd.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.handleSaveAndNextClose = this.handleSaveAndNextClose.bind(this);
      this.getSavedCustomers = this.getSavedCustomers.bind(this);
      this.getVendorItemCustomers = this.getVendorItemCustomers.bind(this);
      this.handleRadioButtonSelect = this.handleRadioButtonSelect.bind(this);
      this.handleSavingCustomersToMultipleItems = this.handleSavingCustomersToMultipleItems.bind(this);
    }

    componentDidMount = () => {
      if (this.props.selectedItems.length <= 1) {
        this.handleRadioButtonSelect('each');
      } else {
        this.setState({ displaySetupOptions: true });
      }
    }

    onAdd = (selectedList, selectedCustomer) => {
      const { customersAdded, customersRemoved, selectedCustomers, changeMessages } = this.state;

      var index = null;

      // if this added customer was previosly removed, remove them from the customersRemoved List
      index = customersRemoved.findIndex(
        (i) => i.code === selectedCustomer.code
      );

      if (index >= 0) customersRemoved.splice(index, 1);

      // if this added customer was part of the selected Customers list, we don't need to save them again.
      index = selectedCustomers.findIndex(
        (i) => i.code === selectedCustomer.code
      );

      if (index >= 0) return;

      changeMessages.push(`Adding Customer: ${selectedCustomer.code}`);

      customersAdded.push(selectedCustomer);
      this.setState({
        customersAdded,
        customersRemoved,
        changeMessages
      });
    }

    onSelect = (selectedList, selectedCustomer) => {
      this.setState({
            selectedCustomers: selectedList
        });
    }

    onUpdate = (selectedCustomer) => {
        const { customersUpdated } = this.state;
        customersUpdated.push(selectedCustomer);
        this.setState({
            customersUpdated
        });
    }
    
    onRemove = (selectedList, removedCustomer) => {
      const { customersRemoved, customersAdded, customersUpdated, changeMessages} = this.state;

      var index = null;

      index = customersAdded.findIndex(
        (i) => i.code === removedCustomer.code
      );

      if (index >= 0) customersAdded.splice(index, 1);

      index = customersUpdated.findIndex(
        (i) => i.code === removedCustomer.code
      );

      if (index >= 0) customersUpdated.splice(index, 1);

      changeMessages.push(`Removing Customer: ${removedCustomer.code}`);

      customersRemoved.push(removedCustomer);

      this.setState({
        customersRemoved,
        customersAdded,
        customersUpdated,
        removedCustomer
      });
    }

    handleSavingCustomersToMultipleItems = async () => {
      const { selectedItems, vendorItemCustomerMultiple, customersAdded, customersRemoved } = this.state;

      for (let i = 0; i < selectedItems.length; i++) {
        let { errorMessages } = this.state;
        
        if (errorMessages.length > 0 ) {
          logger.debug(`%c----------- ERROR MESSAGES FROM MUTLI SAVE -----------`, 'color: red');
          logger.debug(errorMessages);
          break;
        }

        let currentItem = selectedItems[i];

        let selectedCustomer = await vendorItemCustomerMultiple.filter(vendorItemCustomer => vendorItemCustomer.vendorItemId === currentItem.vendorItemId);

        this.setState( { selectedItem: currentItem, vendorItemCustomers: selectedCustomer, customersRemoved, customersAdded });

        if (i === selectedItems.length - 1) {
          await this.handleSaveAndNextClose(1);
        } else {
          await this.handleSaveAndNextClose(0);
        }
      }
    }

    // action == 0, NEXT
    // action == 1, CLOSE
    handleSaveAndNextClose = async (action) => {
        const {
          selectedItem, selectedItems, customersAdded, customersUpdated, customersRemoved, vendorItemCustomers, hooli
        } = this.state;
        const { vendors } = this.state.data;
        const { currentUser } = this.props;

        var customerDetails;
        var vendorItem;
        var errorMessages = [];

        this.setState({ isSaving: true, errorMessages });

        logger.debug(`%cCustomers Added`,'color: green');
        logger.debug(customersAdded);

        logger.debug('Customers Updated');
        logger.debug(customersUpdated);

        logger.debug(`%cCustomers Removed`,'color: red');
        logger.debug(this.state.customersRemoved);
        logger.debug(this.state.customersRemoved.length);

        // POST newly added Customers
        if (customersAdded.length > 0) {  
          for (const customer of customersAdded) {
            try {          
              customerDetails = customer;
              vendorItem = selectedItem;
              const body = {
                  vendorItemId: vendorItem.vendorItemId,
                  itemCode: vendorItem.itemId,
                  defaultVendorFlag: customer.default || false,
                  createUserId: currentUser,
                  updateUserId: currentUser,
                  customerCode: customer.code,
                  vendorCode: this.props.vendorCode
              };

              await postVendorItemCustomer(body, 'someApiToken');
            } 
            catch (err) {
                const resp = await getVendorForCustomerMapping(vendorItem.itemId, customer.code);

                if (resp.length > 0) {
                  const vendorName = vendors[resp[0].vendorCode];
                  errorMessages.push(`There was an issue saving this customer: ${customerDetails.description}. Vendor, ${vendorName}, is already set as the default for this item code: ${vendorItem.itemId}.`);
                } else {
                  errorMessages.push(`There was an issue saving this customer: ${customerDetails.description}, with this vendor-item combination: ${this.props.vendorCode}-${vendorItem.itemId}.`);
                }
                this.setState({ errorMessages, isSaving: false });
            }
          }
        }

        // DELETE customers for the vendor-item combination
        if (customersRemoved.length > 0) {
          for (const customer of customersRemoved) {
            try {
              const selectedCustomer = vendorItemCustomers.filter((vendorItemCustomer) => vendorItemCustomer.customerCode === customer.code)[0];

              customerDetails = customer;
              vendorItem = selectedItem;

              if (selectedCustomer) {
                await deleteVendorItemCustomer(selectedCustomer.vendorItemCustomerId);
              }
            } 
            catch (err) {
                logger.debug(`%cerror calling delete`,'color: red');
                logger.debug(err);
                errorMessages.push(`There was an issue deleting this vendor-item, ${this.props.vendorCode}-${vendorItem.itemId} for customer: ${customerDetails.description}.`);
                this.setState({ errorMessages, isSaving: false });
            }
          } 
        }

        // Update selectedItems
        selectedItems[this.state.currentItemLocation] = selectedItem;     
        let currentItemLocation = errorMessages.length === 0 ? this.state.currentItemLocation + 1 : this.state.currentItemLocation;

        if (action === 1 && errorMessages.length === 0) {
          this.closeModal();
        } else {
          action = 0; // don't close the window and display the error message.
        }

        if (action === 0) {
          const itemCount = selectedItems.length;

          if (currentItemLocation === itemCount) currentItemLocation = 0; // start from the beginning
          const selectedItem = selectedItems[currentItemLocation];

          var selectedCustomers;
          try {
            selectedCustomers = await this.getSavedCustomers(selectedItem);
          } catch {
            selectedCustomers = [];
          }

          this.setState({
              currentItemLocation,
              selectedItem,
              selectedItems,
              selectedCustomers,
              customersAdded: [],
              customersRemoved: [],
              customersUpdated: [],
              isSaving: false
          });
        }
    }

    getVendorItemCustomers = async (selectedItem) => {
        const { vendorItemCustomerMultiple } = this.state;

        try {
            const resp = await getVendorItemCustomersByVendorItemId(selectedItem.vendorItemId);
            vendorItemCustomerMultiple.push(...resp);
            this.setState({ vendorItemCustomers: resp, vendorItemCustomerMultiple });
            return resp;
        } catch (ex) {
            this.setState({ vendorItemCustomers: [] });
            return [];
        }
    }

    getSavedCustomers = async (selectedItem) => {
        let selectedCustomers = [];

        try {
            const resp = await this.getVendorItemCustomers(selectedItem);
            resp.forEach((vendorItemCustomer) => {
                const customers = this.props.data.customerDetails.filter((customer) => customer.code === vendorItemCustomer.customerCode);
                if (customers.length > 0) {
                    const customer = customers[0];
                    customer.default = true; // vendorItemCustomer.defaultVendorFlag;
                    customer.isDirty = false;           
                    selectedCustomers.push(customer);
                }
            });
        } catch (ex) {
            selectedCustomers = [];
        }

        return selectedCustomers;
    }

    closeModal = () => {
        this.props.closeModal();
    }

    handleRadioButtonSelect = async (selectedOption) => {
      let selectedCustomers = [];
      
      this.setState({ 
        data: this.props.data,
        selectedItems: this.props.selectedItems,
        selectedItem: this.props.selectedItems[0]
      });

      if (selectedOption === 'all') {
        //aggregate the customer codes for the ALL the selected items
        this.setState(( { isloadingCustomers: true }));
        let promises = [];
        let selectedItems = this.props.selectedItems;

        selectedItems.forEach(selectedItem => {
          promises.push(this.getSavedCustomers(selectedItem));
        });

        Promise.all(promises).then(resp => {
          resp.forEach(item => selectedCustomers.push(...item));
          selectedCustomers = selectedCustomers.filter((item, idx) => selectedCustomers.indexOf(item) === idx);
          this.setState({ selectedCustomers, isloadingCustomers: false });
        });
      } else {
        selectedCustomers = await this.getSavedCustomers(this.props.selectedItems[0]);
        this.setState({ selectedCustomers });
      }

      this.setState({displayMultiSelect: true, displaySetupOptions: false, shouldEditAllItems: selectedOption === 'all', shouldEditIndividualItems: selectedOption === 'each'});
    }

    render() {
        const { 
          data,
          selectedItem,
          selectedItems,
          errorMessages,
          selectedCustomers,
          displaySetupOptions,
          isSaving,
          shouldEditAllItems,
          shouldEditIndividualItems,
          isloadingCustomers,
          displayMultiSelect,
          changeMessages
        } = this.state;

        const cost = selectedItem !== undefined && selectedItem.cost ? formatCurrency.format(selectedItem.cost) : null;
        const errors = errorMessages.length > 0 ? errorMessages.join('\n') : null;

        return (
          <div className="flex-container-row add-items">
            { shouldEditIndividualItems
              ? <div className="flex-container-row top-level">
                <div className="headline-small fixed-divider">Customer Maintenance For:  </div>
              </div>
              : null
            }

            { shouldEditIndividualItems
              ? <div className="flex-container-row top-level">
                <div className="flex-container-column">
                  <div className="flex-container-row wf-form-element-container">
                    <label className="wf-form-element-label">Description:</label>
                    <div className="body-short-form">{selectedItem.description}</div>
                  </div>

                  <div className="flex-container-row wf-form-element-container">
                    <label className="wf-form-element-label">Item Number:</label>
                    <div className="body-short-form">{selectedItem.itemId}</div>
                  </div>

                  <div className="flex-container-row wf-form-element-container">
                    <label className="wf-form-element-label">Vendor Cost:</label>
                    <div className="body-short-form">{cost}</div>
                  </div>

                  <div className="flex-container-row wf-form-element-container">
                    <label className="wf-form-element-label">Location:</label>
                    <div className="body-short-form">{selectedItem.location}</div>
                  </div>

                  <div className="flex-container-row wf-form-element-container">
                    <label className="wf-form-element-label">Country of Origin:</label>
                    <div className="body-short-form">{selectedItem.countryOfOrigin}</div>
                  </div>
                </div>
              </div>
              : null
            }

            {
              shouldEditAllItems
              ? <div className="items-all">
                { selectedItems.map(item => <div key={item.vendorItemId}>{`${item.itemId} - ${item.description}`}</div>) }
              </div>
              : null
            }        
  
            { !displaySetupOptions && displayMultiSelect
              ? <div className="flex-container-row">
                <div id="customers" className="wf-form-element-container">
                  <label className="wf-form-element-label" htmlFor="customers">
                    Customers
                    :
                  </label>
                  { isloadingCustomers
                    ? <div className="loading-msg">Loading Customers....</div>
                    : null
                  } 
                  <Multiselect 
                    labelName="Customers" 
                    options={data.customerDetails}
                    selectedValues={selectedCustomers}
                    displayValue="description" 
                    onSelect={this.onSelect} 
                    onRemove={this.onRemove}
                    onUpdate={this.onUpdate}
                    onAdd={this.onAdd}
                  />
                </div>
              </div>
              : null
            }

            { shouldEditAllItems
              ? <div style={{paddingLeft: "30px", textAlign: "left"}}>
                { changeMessages.length > 0
                  ? changeMessages.map((item, idx) => <div key={idx}>{item}</div>)
                  : <div style={{color: "green"}}>No Changes</div>
                }
                </div>
              :null
            }

            { isSaving
                ? <PulseModal showPulseModal={this.state.isSaving} />
                : null
            }

            { shouldEditIndividualItems
              ? <div className="flex-container-row">
                <div className="item-count-container">{`Editing Item ${this.state.currentItemLocation + 1} of ${selectedItems ? selectedItems.length : 0}`}</div>
              </div>
              : null
            }

            { shouldEditIndividualItems
              ? <div className="flex-container-row edit-action-buttons">                  
                  <PrimaryButton onClick={() => this.handleSaveAndNextClose(0)} name="Save and Next" />
                  <PrimaryButton onClick={() => this.handleSaveAndNextClose(1)} name="Save and Close" />
                  <SecondaryButton onClick={this.closeModal} name="Return to Dashboard" />
                </div>
              : null
            }

            { shouldEditAllItems && changeMessages.length > 0
              ? <div className="flex-container-row edit-action-buttons">  
                  <PrimaryButton onClick={this.handleSavingCustomersToMultipleItems} name="Save and Close" />
                </div>
              : null
            }

            { errorMessages.length > 0
                ? <div data-testid='error-messages' className="flex-container-row">
                  <div className="error-msg customer-maintenance-errors">{errors}</div>
                </div>
              : null
            }

            { displaySetupOptions
              ? <div className="flex-container-row edit-options">
                  <div className="flex-container-row edit-options" style={{fontSize: "2rem", paddingBottom: "10px"}}>
                      Would you like to:
                  </div>
                  <div className="edit-options">
                      <div className="radio-button-container">
                        <label className="body-short-form">
                          <input type="radio" value="all" onClick={() => this.handleRadioButtonSelect('all')} />
                            <span></span>
                            Apply Changes to All Selected Items
                        </label>
                      </div>
                      <div className="radio-button-container">
                        <label className="body-short-form">
                          <input type="radio" value="each" onClick={() => this.handleRadioButtonSelect('each')} />
                          <span></span>
                          Edit Each Item Individually
                        </label>
                      </div>                  
                  </div>
                </div>
              : null
            }

          </div>
        );
    }
}

export default MaintainCustomers;
